import { Badge } from '@lombok/ui';
import type { BadgeTone } from '@lombok/ui';
import { AVAILABILITY_LABELS_ES, AvailabilityStatus } from '@lombok/shared';
import type { AvailabilityStatus as AvailabilityStatusType } from '@lombok/shared';

/**
 * Customer-facing availability badge. Labels come straight from the shared
 * AVAILABILITY_LABELS_ES map (never hardcoded here, never the exact stock count).
 */
const TONE_BY_AVAILABILITY: Record<AvailabilityStatusType, BadgeTone> = {
  [AvailabilityStatus.DISPONIBLE_HOY]: 'success',
  [AvailabilityStatus.DISPONIBLE_24_72H]: 'info',
  [AvailabilityStatus.BAJO_PEDIDO]: 'warning',
  [AvailabilityStatus.RESERVADO]: 'accent',
  [AvailabilityStatus.AGOTADO]: 'danger',
  [AvailabilityStatus.CONSULTAR]: 'neutral',
};

export interface AvailabilityBadgeProps {
  status: AvailabilityStatusType;
}

export function AvailabilityBadge({ status }: AvailabilityBadgeProps) {
  return <Badge tone={TONE_BY_AVAILABILITY[status]}>{AVAILABILITY_LABELS_ES[status]}</Badge>;
}
